import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import PropType from 'prop-types';
import envList from '../../constants/envList';
import CompareComponent from './compare/CompareComponent';
import ExportEmail from './ExportEmail';
import LandingComponent from './LandingComponent';
import RtMaxSoluceComponent from './rtmax/RtMaxSoluceComponent';
import RtPlusSoluceComponent from './rtplus/RtPlusSoluceComponent';
import StandardSoluceComponent from './standard/StandardSoluceComponent';

const pages = [
  {
    path: '/:env/projet',
    component: LandingComponent,
  },
  {
    path: '/:env/compare',
    component: CompareComponent,
  },
  {
    path: '/:env/standard',
    component: StandardSoluceComponent,
  },
  {
    path: '/:env/rtmax',
    component: RtMaxSoluceComponent,
  },
  {
    path: '/:env/rtplus',
    component: RtPlusSoluceComponent,
  },
  {
    path: '/:env/export',
    component: ExportEmail,
  },
];

class ConnectedApp extends Component {
  static propTypes = {
    match: {
      params: {
        env: PropType.string,
      },
    },
    location: PropType.object,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  _isInEnvList() {
    const { match: {
      params: {
        env,
      },
      url,
    } } = this.props;
    const matchEnv = Object.values(envList).find(authorisedEnv => authorisedEnv.path === env);

    return !!matchEnv || url === '/';
  }

  render() {
    const { location } = this.props;
    return (
      <div>
        <Router>
          <div>
            {/* by security check if the env part is on the autorised env list */}
            { this._isInEnvList()
              ? pages.map(
                page => <Route exact path={page.path} component={page.component} />
              )
              : (
                <Redirect
                  to={{
                    pathname: '/',
                    state: location,
                  }}
                />
              )
            }
          </div>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
});

const App = connect(mapStateToProps)(ConnectedApp);
export default App;



// WEBPACK FOOTER //
// ./src/components/Protected/ProtectedRoute.js